import { Record } from 'immutable';

import { transactionsTypes } from 'app-components/flux/transactions';

export const TransactionStore = Record({
  ...transactionsTypes.mkTransactionStore().toObject(),
  lastReductions: null,
});
